import { all } from 'redux-saga/effects';
// New design
import PageSaga from 'app/store/page/page.saga';

export default function* rootSaga() {
  yield all([
    PageSaga()
  ]);
}